/**
 * <ry-testimonial>
 *
 * Customer testimonial / quote card.
 *
 * Usage:
 * <ry-testimonial name="Jane Doe" role="CTO, Acme Corp" avatar="photo.jpg" stars="5">
 *   This changed everything.
 * </ry-testimonial>
 */

import { RyElement } from '../core/ry-element.js';
import { getIcon } from '../core/ry-icons.js';

export class RyTestimonial extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    if (this.$('[data-ry-target="quote"]')) return;

    const avatar = this.getAttribute('avatar') ?? '';
    const name = this.getAttribute('name') ?? '';
    const role = this.getAttribute('role') ?? '';
    const stars = parseInt(this.getAttribute('stars') ?? '0', 10);
    const quoteText = this.textContent?.trim() ?? '';

    const avatarHTML = avatar
      ? `<div data-ry-target="avatar" class="ry-testimonial__avatar"><img src="${avatar}" alt="${name}"></div>`
      : '';

    const starsHTML = stars > 0
      ? `<div data-ry-target="stars" class="ry-testimonial__stars">${Array.from({ length: stars }, () => `<span class="ry-testimonial__star">${getIcon('star')}</span>`).join('')}</div>`
      : '';

    this.innerHTML = `
      ${avatarHTML}
      ${starsHTML}
      <blockquote data-ry-target="quote" class="ry-testimonial__quote">${quoteText}</blockquote>
      <div data-ry-target="attribution" class="ry-testimonial__attribution">
        <span data-ry-target="name" class="ry-testimonial__name">${name}</span>
        ${role ? `<span data-ry-target="role" class="ry-testimonial__role">${role}</span>` : ''}
      </div>
    `;
  }
}

customElements.define('ry-testimonial', RyTestimonial);
